import ServiceCategoryPage from "../components/ServiceCategoryPage";
import carCleaningService from "../data/services/carCleaningService";

function CarCleaning() {
  return <ServiceCategoryPage service={carCleaningService} />;
}

export default CarCleaning;